import IconClap from './component.jsx'
export default IconClap
